import { ReactComponent as ProgressChartHigh } from '@backrs_ui/common-ui/src/assets/images/progress-circle-high.svg';
import { ReactComponent as ProgressChartLow } from '@backrs_ui/common-ui/src/assets/images/progress-circle-low.svg';
import { ReactComponent as ProgressChartMedium } from '@backrs_ui/common-ui/src/assets/images/progress-circle-medium.svg';
import { ReactComponent as ProgressChartTransparent } from '@backrs_ui/common-ui/src/assets/images/progress-circle-transparent.svg';
import { ReactComponent as ProgressChartVeryHigh } from '@backrs_ui/common-ui/src/assets/images/progress-circle-very-high.svg';

import { Box } from '@mui/material';

export type ProgressCircleChartProps = Readonly<{
  percent: 0 | 25 | 50 | 75 | 100;
}>;

export const ProgressCircleChart = ({ percent }: ProgressCircleChartProps) => {
  const imageMap = {
    0: <ProgressChartTransparent />,
    25: <ProgressChartLow />,
    50: <ProgressChartMedium />,
    75: <ProgressChartHigh />,
    100: <ProgressChartVeryHigh />,
  };

  return <Box>{imageMap[percent]}</Box>;
};
